
  import { defineComponent, PropType } from 'vue';

  import ComponentInput from '@/common/components/ComponentInput.vue';

  import { TFTSWeeklyProductsFilter } from '@/modules/ved/types/fts-weekly';

  import FTSProductsFilter from '../FTSProductsFilter.vue';

  export default defineComponent({
    name: 'FTSWeeklyProductsFilter',
    components: {
      FTSProductsFilter,
      ComponentInput,
    },
    props: {
      modelValue: {
        type: Object as PropType<TFTSWeeklyProductsFilter>,
        required: true,
      },
      disabled: {
        type: Boolean,
      },
    },
    emits: ['update:modelValue'],
    computed: {
      productsAccessor: {
        get() {
          return this.modelValue;
        },
        set(newValue: TFTSWeeklyProductsFilter) {
          this.$emit('update:modelValue', { ...this.modelValue, ...newValue });
        },
      },
    },
  });
